import MedicalDisclaimers from "./MedicalDisclaimers";

export default MedicalDisclaimers;
